module.exports = __webpack_public_path__ + "static/media/logo.68d5f745.svg";